const CameraIcon = () => {
  return (
    <svg width="15" height="15" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.97656 3L6.37656 4.80556H3.75434H1.97656V6.39043V16H17.9766L17.9766 9.41975V4.80556H13.5766L11.9766 3H7.97656Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <circle cx="9.89323" cy="9.91667" r="2.91667" stroke="white" strokeWidth="1.5" />
    </svg>
  )
}

export default CameraIcon
